__turbopack_context__.v({
  "key": "KeyboardKey-module-scss-module__vLg6la__key",
});
